import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { DevPagesRoutingModule } from './dev-pages-routing.module';
import { DevIconsComponent } from './icons/dev-icons.component';
import { UiKitStylesPageComponent } from './ui-kit-styles-page/ui-kit-styles-page/ui-kit-styles-page.component';
import { DevPagesMenuComponent } from './dev-pages-menu/dev-pages-menu/dev-pages-menu.component';
import { DevPageComponent } from './dev-page/dev-page.component';
import { InputPageComponent } from './input-page/input-page.component';

@NgModule({
  imports: [
    SharedModule,
    DevPagesRoutingModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    RouterModule,
  ],
  declarations: [
    DevIconsComponent,
    UiKitStylesPageComponent,
    DevPagesMenuComponent,
    DevPageComponent,
    InputPageComponent,
  ],
  providers: [],
})
export class DevPagesModule {
}
